export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0066FF] via-[#0A1628] to-[#0A1628]"></div>
      
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-20 w-64 h-64 bg-cyan-500/30 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-cyan-400 rounded-full"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animation: `float ${3 + Math.random() * 4}s ease-in-out infinite`,
                animationDelay: `${Math.random() * 2}s`,
              }}
            ></div>
          ))}
        </div>
      </div>

      <div className="relative z-10 text-center px-8 w-full max-w-5xl">
        <h1 className="mb-6">
          <div className="text-6xl md:text-7xl font-bold text-white mb-2">
            SECURE YOUR
          </div>
          <div className="text-6xl md:text-7xl font-serif italic text-[#00D9FF]">
            Digital Freedom
          </div>
        </h1>
        
        <p className="text-xl text-white/80 mb-12 max-w-2xl mx-auto font-light">
          Experience military-grade encryption and lightning-fast connections with ESVICOL VPN. Your privacy is our priority.
        </p>

        <button
          onClick={scrollToContact}
          className="group relative px-10 py-4 bg-[#00D9FF] text-white text-base font-semibold rounded-full hover:bg-[#00B8DD] transition-all duration-300 shadow-lg shadow-cyan-500/50 hover:shadow-cyan-500/70 whitespace-nowrap cursor-pointer"
        >
          Get Protected Now
          <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform inline-block"></i>
        </button>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
      `}</style>
    </section>
  );
}
